import { Button, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material"
import React, { useEffect, useState } from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import PriceTable from "./price-table"
import PriceTableVariation from "./price-table-variation"
import AlertMessage from "src/components/alert-message"
import LockIcon from "@mui/icons-material/Lock"
import { TokenService } from "../../services/token-service"
import DatePickerSelect from "../../components/date/date-picker-select"
import dayjs from "dayjs"
import { DATE_FORMAT } from "../../utils/constants"
import PriceService from "../../services/price-service"

const PriceHomePage = () => {
    const tabs = [
        { id: 0, description: "PREÇOS MTM", verifyPermission: false },
        { id: 1, description: "VARIAÇÃO DIÁRIA", verifyPermission: true }
    ]

    const tokenService = new TokenService()
    const priceService = new PriceService()
    const [tableKey, setTableKey] = useState(null)
    const [exportFileCsv, setExportFileCsv] = useState(() => () => {
    })
    const [selectedTab, setSelectedTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const [alertMessageState, setAlertMessageState] = useState({ open: false, message: "", type: "" })
    const [dateSelected, setDateSelected] = useState(null)
    const [hasPermissionDailyVariation, setHasPermissionDailyVariation] = useState(false)

    // Buscar permissões do usuário
    useEffect(() => {
        loadLastDate()
        loadPermission()
    }, [])

    const loadPermission = () => {
        const VARIACAO_DIARIA_PERMISSAO = "datalake_api_v1_tabela_precos_variacao_diaria_get"
        const hasPermission = tokenService.verifyPermissionApi(VARIACAO_DIARIA_PERMISSAO)
        setHasPermissionDailyVariation(hasPermission)
    }

    const loadLastDate = () => {
        setLoading(true)
        priceService.loadLastDate().then((response) => {
            const { body } = response
            const { data } = body
            setTableKey(Math.random() * 10)
            onChangeDatePickerDate(data)

        }).finally(() => setLoading(false))
    }

    const openAlert = (message, type) => setAlertMessageState({ open: true, message, type })
    const closeAlert = () => setAlertMessageState(prev => ({ ...prev, open: false }))

    const handleToggleChange = (_event, newTab) => {
        if (newTab === null || newTab === undefined || newTab === selectedTab) {
            return
        }
        setSelectedTab(newTab)
    }

    const onChangeDatePickerDate = (value) => {
        setDateSelected(dayjs(value).format(DATE_FORMAT))
        setTableKey(Math.random() * 10)
    }

    const exportFile = async () => {
        setLoading(true)
        await exportFileCsv()
        setLoading(false)
    }

    return (
        <LayoutPage title="Tabela de PU/TIR" loading={loading}>
            <AlertMessage
                open={alertMessageState.open}
                message={alertMessageState.message}
                type={alertMessageState.type}
                close={closeAlert}
            />
            <Grid sx={{ mr: { md: 13, xs: 0 } }}>
                <Grid container direction="row" alignItems={"center"} justifyContent="flex-end" spacing={3}>
                    <Grid item>
                        <ToggleButtonGroup
                            value={selectedTab}
                            exclusive
                            onChange={handleToggleChange}
                            aria-label="toggle tabs"
                        >
                            {tabs.map(({ id, description, flag, verifyPermission }) => {
                                const disabled = flag ? false : false // se "habilitada" for sempre true, isso pode ser simplificado ainda mais
                                const showLock = verifyPermission && !hasPermissionDailyVariation

                                return (
                                    <ToggleButton key={id} value={id} disabled={disabled}>
                                        {description}
                                        {showLock && <LockIcon fontSize="small" sx={{ mr: 0.5 }} />}
                                    </ToggleButton>
                                )
                            })}
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item>
                        <DatePickerSelect value={dateSelected} label="Data de Exibição" onChange={onChangeDatePickerDate} />
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={exportFile}>
                            Exportar para CSV
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                alignContent="flex-start"
                justifyContent="flex-start"
                spacing={0}
                sx={{ p: 0, height: "100%" }}
            >
                <Grid item xs={12} sx={{ height: "100%" }}>
                    {
                        selectedTab === 0 ?
                            <PriceTable key={tableKey}
                                loading={loading}
                                setLoading={setLoading}
                                alert={openAlert}
                                date={dateSelected}
                                setExportFileCsv={setExportFileCsv} /> :
                            <PriceTableVariation
                                key={tableKey}
                                loading={loading}
                                setLoading={setLoading}
                                alert={openAlert}
                                date={dateSelected}
                                setExportFileCsv={setExportFileCsv}
                            />
                    }
                </Grid>
            </Grid>
        </LayoutPage>
    )
}

export default PriceHomePage
